
<template>
    
        <mars-view class="article" :class="{'article-last': last}" @click.native="tapFn(data)"><mars-view class="article-top"><mars-view class="logo">问</mars-view><mars-rich-text class="title" :nodes="data.qaQuestion"></mars-rich-text><mars-view v-if="data.contentType" class="tag">{{ data.contentType }}</mars-view></mars-view><mars-view class="article-content">
        {{ data.qaAnswer }}
    </mars-view><mars-view class="article-law"><mars-image v-if="data.expertInfo && data.expertInfo.name" class="img" :src="data.expertInfo.avatar" :lazy-load="true" @click.native.stop="goExpertInfo(data.expertInfo)"></mars-image><mars-view v-if="data.expertInfo && data.expertInfo.name" class="info" @click.native.stop="goExpertInfo(data.expertInfo)">
            {{ data.expertInfo.name }}
            {{ data.expertInfo.name !== '律临小秘书' && data.expertInfo.name !== '平台律师团队' ? '律师' : '' }}  {{ data.expertInfo.pranticeYear }}
        </mars-view><mars-view v-if="data.expertInfo && data.expertInfo.expertIdent" class="tag" @click.native.stop="goExpertInfo(data.expertInfo)">
            {{ data.expertInfo.expertIdent }}
        </mars-view><mars-view class="time" @click.native.stop="goExpertInfo(data.expertInfo)">{{ data.expertInfo.pubTime }}</mars-view></mars-view></mars-view>
    
</template>

<script>
import { act } from '../../static/utils/navigate.js';
export default {
  name: 'articleItem',
  mounted() {},
  created() {},
  beforeDestroy() {},
  computed: {},
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    index: {
      type: Number,
      default() {
        return 0;
      }
    },
    last: {
      type: Boolean,
      default() {
        return false;
      }
    },
    log: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    // 去文章详情
    tapFn({
      target,
      type,
      id
    }) {
      act({
        target,
        type,
        log: '',
        vm: this
      });
      this.$emit('tapCallBack', this.data, this.index, '');
    },
    goExpertInfo({
      target,
      type,
      id
    }) {
      act({
        target,
        type,
        log: '',
        vm: this
      });
      this.$emit('tapCallBack', this.data, this.index, '-lawyer');
    }
  }
};
</script>

<style scoped>
.article {
  display: flex;
  flex-direction: column;
  padding: 15px 0 14px;
  border-bottom: 1px solid #eee;
  font-family: PingFangSC-Regular;
}
.article .article-top {
  display: flex;
  align-items: center;
}
.article .article-top .logo {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #00bcbe;
  font-size: 14px;
  border: 1px solid #b2eaeb;
  box-sizing: border-box;
  border-radius: 2px;
}
.article .article-top .title {
  max-width: 76%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 19px;
  color: #000;
  letter-spacing: 0;
  margin-left: 8px;
}
.article .article-top .tag {
  margin-left: 2px;
  border: 1px solid #efb9b9;
  color: #f13f40;
  padding: 0 6px;
  border-radius: 12px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  line-height: 12px;
  transform: scale(0.83, 0.83);
  height: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.article .article-content {
  margin-top: 8px;
  line-height: 24px;
  color: #555;
  font-size: 14px;
  overflow: hidden;
  display: -webkit-box;
  word-break: break-all;
  text-overflow: ellipsis;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /*! autoprefixer: on */
  -webkit-line-clamp: 2;
}
.article .article-law {
  padding-top: 6px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.article .article-law .img {
  width: 24px;
  height: 24px;
  display: block;
  border-radius: 50%;
}
.article .article-law .info {
  font-family: PingFangSC-Regular;
  color: #999;
  margin-left: 5px;
  max-width: calc(100% - 106px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
}
.article .article-law .tag {
  background: #f3f5fa;
  margin-left: 2px;
  border: 1px solid #c7cfeb;
  color: #4661bf;
  padding: 0 6px;
  border-radius: 12px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  line-height: 12px;
  transform: scale(0.83, 0.83);
  height: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.article .article-law .time {
  margin-left: auto;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999;
  line-height: 14px;
}
.article-last {
  border-bottom: 0;
}
 /deep/ em {
  color: #f11;
  text-decoration: none;
  font-style: normal;
}
.dynamic {
  color: #f11;
  text-decoration: none;
  font-style: normal;
}

</style>
